import { countUnicodeCodePoints } from "@/lib/alfred-field-validation"

interface CharacterCounterProps {
  value: string
  maxLength: number
}

export function CharacterCounter({ value, maxLength }: CharacterCounterProps) {
  const characterCount = countUnicodeCodePoints(value)

  return (
    <p
      className={`text-right text-xs tabular-nums ${
        characterCount > maxLength ? "text-destructive" : "text-muted-foreground"
      }`}
      aria-label={`${characterCount} of ${maxLength} characters used`}
    >
      {characterCount}/{maxLength}
    </p>
  )
}
